<template>
  <v-stepper
    v-model="currentStepIndex"
    class="elevation-0"
  >
    <v-stepper-header
      class="elevation-0"
      style="flex-wrap: nowrap; overflow: auto"
    >
      <v-stepper-step
        v-for="step in steps"
        :key="'step-header-' + step.id"
        :editable="editable"
        :step="step.id"
        class="v-stepper__step--custom-no-label unselectable"
      />
    </v-stepper-header>
    <v-stepper-items>
      <v-stepper-content
        v-for="step in steps"
        :key="'step-content-' + step.id"
        :step="step.id"
        class="pa-0"
      >
        <v-card flat>
          <v-layout
            align-center
            justify-space-between
          >
            <v-btn
              :disabled="currentStepIndex == 1"
              flat
              large
              :title="$t('goBack')"
              style="height: 400px; width: 48px; min-width: 48px"
              class="step-button ml-0 mr-3 my-0"
              @click="currentStepIndex -= 1"
            >
              <v-icon
                v-if="currentStepIndex > 1"
                large
              >
                keyboard_arrow_left
              </v-icon>
            </v-btn>
            <v-layout
              align-center
              wrap
            >
              <v-flex
                xs12
                sm5
              >
                <div class="step--text unselectable">
                  {{ $t(step.text) }}
                </div>
              </v-flex>
              <v-flex
                xs12
                sm7
              >
                <v-img
                  :src="step.image"
                  max-height="400"
                  :style="{
                    'min-height': $vuetify.breakpoint.mdAndUp
                      ? '400px'
                      : '100px',
                  }"
                  contain
                  :class="{
                    'ml-4': $vuetify.breakpoint.mdAndUp,
                    'mt-3': $vuetify.breakpoint.smAndDown,
                  }"
                />
              </v-flex>
            </v-layout>
            <v-btn
              :disabled="currentStepIndex >= steps.length"
              large
              flat
              :title="$t('goForward')"
              class="step-button ml-3 mr-0 my-0"
              data-cy="menu-how-to-stepper-next-btn"
              style="height: 400px; width: 72px; min-width: 72px"
              @click="currentStepIndex += 1"
            >
              <v-icon
                v-if="currentStepIndex < steps.length"
                large
              >
                keyboard_arrow_right
              </v-icon>
            </v-btn>
          </v-layout>
        </v-card>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
const MENU_START_WIZARD_IMAGE__URL_01 =
  'https://cms.myshopradio.de/filer/canonical/1713268247/1160/';
const MENU_START_WIZARD_IMAGE__URL_02 =
  'https://cms.myshopradio.de/filer/canonical/1713268247/1159/';
const MENU_START_WIZARD_IMAGE__URL_03 =
  'https://cms.myshopradio.de/filer/canonical/1713268243/1157/';
const MENU_START_WIZARD_IMAGE__URL_04 =
  'https://cms.myshopradio.de/filer/canonical/1713268243/1158/';
const MENU_START_WIZARD_IMAGE__URL_05 =
  'https://cms.myshopradio.de/filer/canonical/1713268243/1156/';
const MENU_START_WIZARD_IMAGE__URL_06 =
  'https://cms.myshopradio.de/filer/canonical/1713268247/1161/';

// Note: The 'text' values are translation keys and need a $t(...) call in the template.
export const HOW_TO_STEPS = [
  {
    id: 1,
    image: MENU_START_WIZARD_IMAGE__URL_01,
    text: 'menuHowToStepperStep_01',
  },
  {
    id: 2,
    image: MENU_START_WIZARD_IMAGE__URL_02,
    text: 'menuHowToStepperStep_02',
  },
  {
    id: 3,
    image: MENU_START_WIZARD_IMAGE__URL_03,
    text: 'menuHowToStepperStep_03',
  },
  {
    id: 4,
    image: MENU_START_WIZARD_IMAGE__URL_04,
    text: 'menuHowToStepperStep_04',
  },
  {
    id: 5,
    image: MENU_START_WIZARD_IMAGE__URL_05,
    text: 'menuHowToStepperStep_05',
  },
  {
    id: 6,
    image: MENU_START_WIZARD_IMAGE__URL_06,
    text: 'menuHowToStepperStep_06',
  },
];

console.log();
console.log('HOW_TO_STEPS', HOW_TO_STEPS);
console.log();

export default {
  props: {
    stepIndex: {
      type: Number,
      required: true,
    },
    /**
     * Whether the user can jump directly to specific steps.
     *
     * Otherwise he must progress linearly in order.
     */
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      steps: HOW_TO_STEPS,
    };
  },
  computed: {
    currentStepIndex: {
      get() {
        return this.stepIndex;
      },
      set(value) {
        this.$emit('update:stepIndex', value);
      },
    },
  },
};
</script>

<style scoped>
.step {
  display: flex;
  flex-flow: row nowrap;
}

.step-button:hover {
  background: rgba(0, 0, 0, 0.08);
}

.step--circle {
  min-width: 40px;
  min-height: 40px;
  max-width: 40px;
  max-height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
}

.step--text {
  display: flex;
  align-items: flex-start;
  font-size: 1.33rem;
}

/** Custom stepper header with larger circle/number and no label text. */
.v-stepper__header >>> .v-stepper__step.v-stepper__step--custom-no-label {
  width: 100%;
  justify-content: center;
  padding: 0;
}
.v-stepper__header
  >>> .v-stepper__step.v-stepper__step--custom-no-label
  .v-stepper__step__step {
  margin-right: 0;
  height: 36px;
  min-height: 36px;
  min-width: 36px;
  width: 36px;
  font-size: large;
}
</style>



// WEBPACK FOOTER //
// src/components/Menu/MenuHowToStepper.vue